import { render, staticRenderFns } from "./commissionList.vue?vue&type=template&id=63a984b1&scoped=true&"
import script from "./commissionList.vue?vue&type=script&lang=ts&"
export * from "./commissionList.vue?vue&type=script&lang=ts&"
import style0 from "./commissionList.vue?vue&type=style&index=0&id=63a984b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a984b1",
  null
  
)

export default component.exports